import { defineComponent as r, computed as f } from "vue";
const m = /* @__PURE__ */ r({
  __name: "badge",
  props: {
    defaultFontSize: { default: void 0 },
    mobileFontSize: { default: void 0 },
    disableMinContent: { type: Boolean },
    positionDefault: { default: void 0 },
    positionMobile: { default: void 0 },
    magenta: { type: Boolean },
    black: { type: Boolean },
    white: { type: Boolean },
    bold: { type: Boolean },
    text: { default: void 0 }
  },
  setup(p, { expose: b }) {
    const t = p, n = (e, o) => {
      const a = [];
      return ["top", "right", "bottom", "left"].forEach((l) => {
        const i = e[l];
        if (!(!i && i !== 0)) {
          if (Number.isNaN(Number(i))) {
            a.push(`--badge-${o}-${l}: ${i};`);
            return;
          }
          a.push(`--badge-${o}-${l}: ${i}px;`);
        }
      }), a.join(" ");
    }, s = (e, o) => isNaN(e) ? `--badge-${o}-size: ${e};` : `--badge-${o}-size: ${e}px;`, u = f(() => {
      const e = [];
      return t.positionMobile && e.push(n(t.positionMobile, "xs")), t.positionDefault && e.push(n(t.positionDefault, "sm")), t.mobileFontSize && e.push(s(t.mobileFontSize, "xs")), t.defaultFontSize && e.push(s(t.defaultFontSize, "sm")), e.join(" ").trim();
    }), d = f(() => {
      const e = [];
      return t.bold && e.push("badge--bold"), t.magenta ? e.push("badge--magenta") : t.black ? e.push("badge--black") : t.white && e.push("badge--white"), t.disableMinContent || e.push("badge--min-content"), e.join(" ");
    });
    return b({ getPositions: n, containerClasses: d, styles: u }), { __sfc: !0, props: t, getPositions: n, getFontSize: s, styles: u, containerClasses: d };
  }
});
export {
  m as default
};
